/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { CSSObject } from '@emotion/react';
import { ThemeOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
	interface TypographyVariants {
		body1AsH1: React.CSSProperties;
		body1AsH2: React.CSSProperties;
		body2AsH2: React.CSSProperties;
		h3AsH1: React.CSSProperties;
		h4AsH1: React.CSSProperties;
		h6AsH2: React.CSSProperties;
		strong: React.CSSProperties;
		h2Plain?: React.CSSProperties;
	}

	// allow configuration using `createTheme`
	interface TypographyVariantsOptions {
		body1AsH1?: React.CSSProperties;
		body1AsH2?: React.CSSProperties;
		body2AsH2?: React.CSSProperties;
		h3AsH1?: React.CSSProperties;
		h4AsH1?: React.CSSProperties;
		h6AsH2?: React.CSSProperties;
		strong?: React.CSSProperties;
		miniBody1?: React.CSSProperties;
		h2Plain?: CSSObject;
	}
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
	interface TypographyPropsVariantOverrides {
		body1AsH1: true;
		body1AsH2: true;
		body2AsH2: true;
		h3AsH1: true;
		h4AsH1: true;
		h6AsH2: true;
		strong: true;
		miniBody1: true;
		h2Plain: true;
	}
}

export const typography: ThemeOptions = {
	typography: {
		htmlFontSize: 15,
		fontFamily: ['mikado-regular','effra','chaloops-bold'].join(','),
		h1: {
			fontSize: 28,
			fontFamily: 'chaloops-bold',
			fontWeight: 400,
			marginBottom:16,
			'@media (max-width:600px)': {
           	 	fontSize: 26, 
         	},
		},
		h2: {
			fontSize: 22,
			fontFamily: 'chaloops-bold',
			fontWeight: 400,
			'@media (max-width:600px)': {
           	 	fontSize: 22, 
         	},
		},
		h3: {
			fontSize: 18,
			fontWeight: 'bold',
			'@media (max-width:600px)': {
           	 	fontSize: 18, 
         	},
		},
		h4: {
			fontSize: 16,
			fontWeight: 'bold',
			'@media (max-width:600px)': {
           	 	fontSize: 16, 
         	},
		},
		h5: {
			fontSize: 16,
			fontWeight: 'bold',
		},
		h6: {
			fontSize: 14,
			fontWeight: 'bold',
		},
		subtitle1: {
			fontSize: 16,
			fontWeight: 600,
		},
		subtitle2: {
			fontSize: 16,
			fontWeight: 400,
		},
		body1: {
			fontSize: 16,
			fontWeight: 400,
		},
		body2: {
			fontSize: 16,
			fontWeight: 600,
		},
		miniBody1: {
			fontSize: 14,
			fontWeight: 400,
			display:'block',
		},
		button: {
			fontSize: 16,
			textTransform: 'none',
			fontWeight: 'bold',
		},
		caption: {
			fontSize: 13,
			fontWeight: 400,
		},
		strong: {
			fontWeight: 700,
		},
		overline: {
			fontSize: 13,
			textTransform: 'uppercase',
			fontWeight: 600,
			letterSpacing: 1,
		},
	},
};